export default __webpack_public_path__ + "static/joko-app-screenshot-home-3-fr@2x-801c35cf467c69b80de3050d2c8432b8.webp";